import React, { useState, useEffect } from 'react';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import classNames from 'classnames';

import styles from './plannav.module.css';

export const PlanNav = ({ items, activeScroll }) => {
  const [active, setActive] = useState(activeScroll);

  useEffect(() => {
    setActive(activeScroll);
  }, [activeScroll]);

  return (
    <div className={styles.planButtons}>
      {items.map((section, index) => {
        return (
          <div>
            <button
              type="button"
              className={classNames(
                styles.planSideButton,
                active === section.value ? styles.isActive : ''
              )}
              onClick={() => {
                document
                  .getElementById(section.value)
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                setTimeout(() => {
                  setActive(section.value);
                }, 1300);
              }}
              key={section.value}
            >
              <IconSymbol
                icon={section.icon}
                color={active === section.value ? '#196ecf' : '#002677'}
                variant="outlined"
              />
              {section.title}
            </button>
          </div>
        );
      })}
    </div>
  );
};
